import React from "react";

import MapPinContactUs from "../../../../icons/MapPinContactUs";

interface props {
  city?: string;
  address?: string;
}
export const OfficeLocationCard = ({ city, address }: props) => {
  return (
    <>
      <div className="lg:flex lg:justify-between lg:items-center lg:max-w-[754px] lg:space-x-3 w-full mt-6 clip-path-mobileClipPolygonTopLeft  bg-brand-lightBlue pt-20 lg:pt-[30px] lg:pb-[30px] pb-[48px] pl-8 lg:pl-11 pr-[14px] lg:pr-8">
        <div className="flex space-x-3">
          <MapPinContactUs />
          <p className="font-spaceGrotesk uppercase font-normal text-mobile-h3 lg:text-web-h3 leading-[30px] lg:leading-20 text-brand-textBlack">
            {city}
          </p>
        </div>
        <p className="mt-4 pl-[52px] lg:max-w-[431px] lg:mt-0 font-openSans font-normal text-mobile-body-sm lg:text-[20px] leading-4 lg:leading-6 text-brand-textLightGrey">
          {address}
        </p>
      </div>
    </>
  );
};

export default OfficeLocationCard;
